import { isMobile, isTablet, isMobileOnly } from 'mobile-device-detect';
import moment from "moment";
import { optionUTC } from "@/_helpers/globalData.js";
import jsonData from '/public/domainConfig.json';
import { _alert } from "./function.js";

const Global = {
    data() {
        return {
            isMobiTablet: isMobile,
            mobi: isMobileOnly,
            tablet: isTablet,
            widthWindow: 0,
            innerWidth: 1140,
            innerWidthMobi: 736,
            optionUTC: optionUTC(),
            jsonData: jsonData,

            ruleName: [
                value => !!value || this.$t('NOT_EMPTY'),
                value => (value && value.length <= 250 && value.length >= 2) || this.$t('DATA_INPUT_INVALID'),
                value => {
                    const pattern = /[^\s]./
                    return pattern.test(value) || this.$t('DATA_INPUT_INVALID')
                },
            ],
            ruleDesc: [
                value => !!value || this.$t('NOT_EMPTY'),
                value => {
                    const pattern = /[^\s]./
                    return pattern.test(value) || this.$t('DATA_INPUT_INVALID')
                },
                value => (value && value.length <= 3000 && value.length >= 2) || this.$t('DATA_INPUT_INVALID'),
            ],
            ruleDescNotRequired: [
                value => (!value || value.length <= 3000) || this.$t('DATA_INPUT_INVALID'),
            ],
            ruleCode: [
                value => !!value || this.$t('NOT_EMPTY'),
                value => (value && value.length <= 20 && value.length >= 2) || this.$t('RULE_CODE'),
                value => {
                    const pattern = /^[a-zA-Z0-9.\-_\s]+$/
                    return pattern.test(value) || this.$t('RULE_CODE')
                },
            ],
            ruleEmail: [
                value => !!value || this.$t('NOT_EMPTY'),
                value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || this.$t('DATA_INPUT_INVALID')
                },
            ],
            ruleEmailWarning: [
                value => !!value || this.$t('NOT_EMPTY'),
                value => {
                    if (typeof value !== 'string') return this.$t('DATA_INPUT_INVALID');
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    const values = value.includes(",") ? value.split(",") : [value];
                    const isValid = values.every(v => pattern.test(v.trim()));
                    return isValid || this.$t('DATA_INPUT_INVALID');
                },
            ],
            ruleRequiedRoomTye: [
                value => !!value || this.$t('NOT_EMPTY')
            ],
            ruleRequied: [
                value => !!value || this.$t('NOT_EMPTY'),
                value => {
                    const pattern = /[^\s]./
                    return pattern.test(value) || this.$t('DATA_INPUT_INVALID')
                },
            ],
            ruleVat: [
                value => parseFloat(value) >= 0 || this.$t('NOT_EMPTY'),
                value => (parseFloat(value) >= 0 && parseFloat(value) <= 100) || this.$t('DATA_INPUT_INVALID'),
                value => {
                    const pattern = /^[0-9]+$/
                    return pattern.test(value) || this.$t('DATA_INPUT_INVALID')
                },
            ],
            ruleNumber: [
                value => parseFloat(value) >= 0 || this.$t('DATA_INPUT_INVALID'),
                value => {
                    const pattern = /^[0-9].+$/
                    return pattern.test(value) || this.$t('DATA_INPUT_INVALID')
                },
            ],
            ruleBankAccount: [
                value => {
                    const pattern = /^[0-9].+$/
                    return (!value || pattern.test(value)) || this.$t('DATA_INPUT_INVALID')
                },
            ],
            ruleFax: [
                value => {
                    const pattern = /[a-zA-Z].+$/
                    return (!value || !pattern.test(value)) || this.$t('DATA_INPUT_INVALID')
                },
            ],
            rulePhone: [
                value => {
                    const pattern = /[0-9-()\s]$/
                    return (!value || pattern.test(value)) || this.$t('DATA_INPUT_INVALID')
                },
            ],
            ruleRequiedNoMess: [
                value => !!value || '',
            ],
            ruleRequiedArrNoMess: [
                value => (!!value && value.length > 0) || '',
            ],
            ruleEmailNotRequied: [
                value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return (!value || pattern.test(value)) || this.$t('DATA_INPUT_INVALID')
                },
            ],
            ruleMoney: [
                value => parseFloat(value) > 0 || this.$t('DATA_INPUT_INVALID'),
                value => {
                    const pattern = /^[0-9.,]+$/
                    return pattern.test(value) || this.$t('DATA_INPUT_INVALID')
                },
            ],
            itemsPerPageArray: [5, 10, 15, 20, 50],
            selectedOTAGlobal: ['EZ_BE'],
            selectedOTAGlobalAndCtrip: ['EZ_BE', 'TRIP_COM'],
            domain: window.location.hostname || "",
            version: `v${localStorage.getItem('app_version')}` || "v0.0.0",
            ezPayUrl: process.env.VUE_APP_EZPAY_URL || "http://localhost:8088",
            currencyData: {
                noDecimal: ["VND", "JPY", "KRW", "MMK", "LAK", "ISK"],
                hasDecimal: [
                    "USD",
                    "CAD",
                    "GBP",
                    "INR",
                    "EUR",
                    "RUB",
                    "KHR",
                    "CNY",
                    "THB",
                    "NOK",
                    "SEK",
                    "DKK",
                ],
                decimalDot: ["en", "ja", "ko", "zh", "hi", "th", "lo", "km", "my"],
                decimalComma: ["vi", "fr", "es", "ru"],
                locales: {
                    vi: { code: "vi-VN", decimal: ",", thousand: "." },
                    en: { code: "en-US", decimal: ".", thousand: "," },
                    ja: { code: "ja-JP", decimal: ".", thousand: "," },
                    ko: { code: "ko-KR", decimal: ".", thousand: "," },
                    zh: { code: "zh-CN", decimal: ".", thousand: "," },
                    hi: { code: "hi-IN", decimal: ".", thousand: "," },
                    ru: { code: "ru-RU", decimal: ",", thousand: " " },
                    fr: { code: "fr-FR", decimal: ",", thousand: " " },
                    es: { code: "es-ES", decimal: ",", thousand: "." },
                    th: { code: "th-TH", decimal: ".", thousand: "," },
                    lo: { code: "lo-LA", decimal: ".", thousand: "," },
                    km: { code: "km-KH", decimal: ".", thousand: "," },
                    my: { code: "my-MM", decimal: ".", thousand: "," },
                },
                prefixCurrency: ["en", "ja", "ko", "zh", "hi", "th"],
                suffixCurrency: ["vi", "fr", "es", "ru", "lo", "km", "my"],
            },
            i18nLocale: null
        };
    },
    mounted() {
        if (this.$i18n) {
            this.i18nLocale = this.$i18n.locale;
        }
    },
    methods: {
        charCount(value, max) {
            return `${(value || '').length} / ${max}`
        },
        handleMaxLength(e, max) {
            const input = e.target
            const value = input.value
            if (
                value.length >= max &&
                e.type === 'keydown' &&
                !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)
            ) {
                e.preventDefault()
                return
            }

            if (e.type === 'paste') {
                e.preventDefault()
                const paste = (e.clipboardData || window.clipboardData).getData('text')
                input.value = (value + paste).slice(0, max)
                input.dispatchEvent(new Event('input'))
            }
        },
        timeOutChange(value) {
            if (this.currencyData.noDecimal.includes(this.usedCurrency)) return 0; 
            const decimal = this.currencyData.locales[this.i18nLocale].decimal || '';
            value = value.toString();
            if (!value.includes(decimal)) return 0;
            let parts = value.split(decimal);
            if(parts[1].length == 2) return 0;
            return 1000;
        },
        setCurrency(value, allowMinusNumber = false) {
            value = this.validateCurrency(value, allowMinusNumber);
            return this.convertCurrencyToNumber(value, allowMinusNumber);
        },
        keyCurrencyDown($event, currency, allowMinusNumber = false, isPecent = false) {
            let key = $event.key;
            let inputValue = $event.target.value;
            let cursorPosition = $event.target.selectionStart;
            if (key == "Backspace" || key == "Delete" || key == "ArrowLeft" || key == "ArrowRight" || key == "Tab"){return}
            const localeData = this.currencyData.locales[this.$i18n.locale];
            const decimal = localeData && localeData.decimal ? localeData.decimal : null;
            const allowDecimal = !this.currencyData.noDecimal.includes(currency);
            if (($event.ctrlKey || $event.metaKey) && (key === 'v' || key === 'V')) {
                return;
            }
            
            if (
                isPecent && 
                (!/[0-9]/.test(key) || inputValue.toString().length >= 3)
            ) {
                $event.preventDefault();
                return;
            }

            if (
                !/^[0-9]$/.test(key) &&
                !(
                    (key === '-' && allowMinusNumber && cursorPosition === 0 && !inputValue.includes('-')) ||
                    (
                        key === decimal && 
                        allowDecimal && 
                        (
                            cursorPosition === inputValue.length || 
                            ( cursorPosition === inputValue.length -  1 && inputValue.length >= 2) || 
                            (cursorPosition === inputValue.length -  2 && inputValue.length >= 3)
                        ) && 
                        !inputValue.includes(decimal)
                    )
                )
            ) {
                $event.preventDefault();
                return;
            }

            let parts = inputValue.split(decimal);
            let integerPart = parts[0].replace(/\D/g, '');

            let hasMinus = inputValue.startsWith('-');
            
            let decimalIndex = inputValue.indexOf(decimal);
            if (decimalIndex === -1) decimalIndex = inputValue.length;

            if (key === '-' && cursorPosition === 0 && !hasMinus) {
                return;
            }

            if (cursorPosition <= decimalIndex && integerPart.length >= 9 && key !== decimal) {
                $event.preventDefault();
                return;
            }

            let decimalPart = parts[1] ? parts[1].replace(/\D/g, '') : '';
            if (
                key !== decimal && 
                inputValue.includes(decimal) && 
                cursorPosition > inputValue.indexOf(decimal) && 
                decimalPart.length >= 2
            ) {
                $event.preventDefault();
            }
        },
        formatCurrency(amount) {
            return new Intl.NumberFormat(this.currencyData.locales[this.i18nLocale].code, {
                minimumFractionDigits: this.currencyData.noDecimal.includes(this.usedCurrency)
                    ? 0
                    : 2,
                maximumFractionDigits: this.currencyData.noDecimal.includes(this.usedCurrency)
                    ? 0
                    : 2,
            }).format(amount);
        },
        formatCurrencyWithSymbol(amount) {
            const format = new Intl.NumberFormat(this.currencyData.locales[this.i18nLocale].code, {
                minimumFractionDigits: this.currencyData.noDecimal.includes(this.usedCurrency)
                    ? 0
                    : 2,
                maximumFractionDigits: this.currencyData.noDecimal.includes(this.usedCurrency)
                    ? 0
                    : 2,
            }).format(amount);
            return `${format} ${this.usedCurrency}`;
        },
        protectionRateInvalid(priceMin, priceMax, value) {
            if (
                (priceMin >= 0 && value >= 0 && parseFloat(priceMin) > parseFloat(value)) ||
                (priceMax >= 0 && value >= 0 && parseFloat(priceMax) < parseFloat(value))
            ) {
                return true;
            }
            return false;
        },
        validateCurrency(input, allowMinusNumber = false) {
            if (!input) return input;
            let localeSettings = this.currencyData.locales[this.i18nLocale];
            
            if (!localeSettings) {
                return input;
            }

            let decimalSeparator = localeSettings.decimal;
            let thousandSeparator = localeSettings.thousand;
            let allowDecimal = this.currencyData.hasDecimal.includes(this.usedCurrency);
            let noDecimal = this.currencyData.noDecimal.includes(this.usedCurrency);
            let isNegative = allowMinusNumber && input.startsWith("-");
            input = input.toString().replace(new RegExp(`[^0-9${allowDecimal ? decimalSeparator : ""}]`, "g"), "");

            if (allowDecimal) {
                let parts = input.split(decimalSeparator);
                if (parts.length > 2) parts = [parts[0], parts.slice(1).join("")];
                input = parts.join(decimalSeparator);

                if (parts.length === 2) {
                    let decimalPart = parts[1].padEnd(2, "0").substring(0, 2);
                    input = decimalPart == '00' ? parts[0] : parts[0] + decimalSeparator + decimalPart;
                }
            } else {
                input = input.replace(new RegExp(`\\${decimalSeparator}`, "g"), "");
            }

            input = input.replace(/^0+(\d)/, "$1");

            if (isNegative) {
                input = "-" + input;
            }
            let numberValue = noDecimal ? parseInt(input, 10) : parseFloat(input.replace(decimalSeparator, "."));
            if (isNaN(numberValue)) {
                return 0;
            }

            let [integerPart, decimalPart] = noDecimal ? [numberValue.toString(), ""] : input.split(decimalSeparator);
            integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
            return decimalPart ? `${integerPart}${decimalSeparator}${decimalPart}` : integerPart;
        },
        convertCurrencyToNumber(value, allowMinusNumber = false) {
            if (!value) return '';
            let localeSettings = this.currencyData.locales[this.i18nLocale];
            
            if (!localeSettings) {
                return input;
            }

            let decimalSeparator = localeSettings.decimal;
            let thousandSeparator = localeSettings.thousand;
            let allowDecimal = this.currencyData.hasDecimal.includes(this.usedCurrency);
            let isNegative = allowMinusNumber && value.startsWith("-");
            value = value.replace(new RegExp(`\\${thousandSeparator}`, "g"), "");
            value = value.replace(new RegExp(`[^0-9${allowDecimal ? decimalSeparator : ""}]`, "g"), "");

            if (allowDecimal) {
                let parts = value.split(decimalSeparator);
                if (parts.length > 2) parts = [parts[0], parts.slice(1).join("")];
                value = parts.join(decimalSeparator);

                if (parts.length === 2) {
                    let decimalPart = parts[1].padEnd(2, "0").substring(0, 2);
                    value = parts[0] + decimalSeparator + decimalPart;
                }
            }
            value = value.replace(/^0+(\d)/, "$1").replace(decimalSeparator, ".");
            if (isNegative) {
                value = "-" + value;
            }
            return isNaN(value) ? '' : value;
        },
        convertDecimalViaLocal(value, allowMinusNumber = false) {
            if (value === null || value === undefined || value === '') return '';
            value = value.toString();
            if (this.currencyData.noDecimal.includes(this.usedCurrency)) {
                value = value.split('.')[0];
            }
            if (this.currencyData.decimalComma.includes(this.i18nLocale)) {
                value = value.replace('.', ',');
            }
            return this.validateCurrency(value, allowMinusNumber);
        },
        isSixMonthsOrLess(date1, date2) {
            const firstDate = new Date(date1);
            const secondDate = new Date(date2);
    
            // Tính toán sự khác biệt về năm và tháng
            const yearDifference = secondDate.getFullYear() - firstDate.getFullYear();
            const monthDifference = secondDate.getMonth() - firstDate.getMonth();
            const totalMonthsDifference = yearDifference * 12 + monthDifference;
    
            if (totalMonthsDifference < 6) {
                return -1;
            } else if (totalMonthsDifference > 6) {
                return 1;
            } else {
                // Nếu tổng số tháng là 6, so sánh chính xác đến ngày, giờ, phút, giây
                if (
                    secondDate.getDate() > firstDate.getDate() ||
                    (secondDate.getDate() === firstDate.getDate() &&
                        (secondDate.getHours() > firstDate.getHours() ||
                        (secondDate.getHours() === firstDate.getHours() &&
                            (secondDate.getMinutes() > firstDate.getMinutes() ||
                            (secondDate.getMinutes() === firstDate.getMinutes() &&
                                secondDate.getSeconds() >= firstDate.getSeconds())))))
                ) {
                    return 1;
                } else if (
                    secondDate.getDate() < firstDate.getDate() ||
                    (secondDate.getDate() === firstDate.getDate() &&
                        (secondDate.getHours() < firstDate.getHours() ||
                        (secondDate.getHours() === firstDate.getHours() &&
                            (secondDate.getMinutes() < firstDate.getMinutes() ||
                            (secondDate.getMinutes() === firstDate.getMinutes() &&
                                secondDate.getSeconds() < firstDate.getSeconds())))))
                ) {
                    return -1;
                } else {
                    return 0;
                }
            }
        },
        updateItemsPerPage(number, itemsPerPage) {
            itemsPerPage = number
        },
        get_day_of_time(d1, d2) {
            let ms1 = d1.getTime();
            let ms2 = d2.getTime();
            return Math.ceil((ms2 - ms1) / (24 * 60 * 60 * 1000));
        },
        fnItemTab(items) {
            const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
            const userRole = currentUser.user.roles.map(role => role.fnCode);
            // Level 1 menu: check
            const hiddenLevel1Item = [];
            for (const subheaderItem of items) {
                if (subheaderItem.roles) {
                    let isVisible = true;
                    for (const role of subheaderItem.roles) {
                        if (userRole.indexOf(role) < 0) {
                            isVisible = false;
                            break;
                        }
                    }
                    if (!isVisible) {
                        hiddenLevel1Item.push(subheaderItem);
                    }
                }
            }
            for (const subheaderItem of hiddenLevel1Item) {
                const index = items.findIndex(
                    item => item.routeName === subheaderItem.routeName
                );
                if (index > -1) {
                    items.splice(index, 1);
                }
            }
            return items;
        },
        notBeforeToday(date) {
            const today = new Date();
            const tomorrow = new Date();
            tomorrow.setDate(today.getDate() + 365 * 2);
            today.setHours(0, 0, 0, 0);
            return date < today || date > tomorrow;
        },
        changeRoomSelect(data) {
            if (data.length > 0) {
                // this.$router.replace({
                //     query: {
                //         roomId: data,
                //     },
                // });
                // const urlParams = new URLSearchParams(window.location.search);
                // const obParams = {
                //     'roomId': urlParams.getAll('roomId') ? [...urlParams.getAll('roomId')] : null,
                //     'otaId': urlParams.getAll('otaId') ? [...urlParams.getAll('otaId')] : null,
                //     'metaData': urlParams.getAll('metaData') ? [...urlParams.getAll('metaData')] : null,
                //     'roomRateId': urlParams.getAll('roomRateId') ? [...urlParams.getAll('roomRateId')] : null,
                // };
                // localStorage.removeItem('paramsUpdateRoomSale');
                // localStorage.setItem('paramsUpdateRoomSale', JSON.stringify(obParams));
            }
        },
        night(ci, co) {
            const a = moment(ci);
            const b = moment(co);
            return b.diff(a, 'days');
        },
        utcConvertToLocalTimeZone(date) {
            if (!date) return "";
            const outputFormat = this.$i18n.locale === 'en' ? "YYYY/MM/DD HH:mm:ss" : "DD/MM/YYYY HH:mm:ss";
            var d = new Date(date + 'Z');
            const day = d.toLocaleString(
                'en-US',
                { timeZone: this.timeZoneStrHotel }
            );
            return moment(day).format(outputFormat);
        },
        utcConvertToLocalTimeZoneAndFomat(date) {
            if (!date) return "";
            const outputFormat = this.$i18n.locale === 'en' ? "YYYY/MM/DD" : "DD/MM/YYYY";
            var d = new Date(date + 'Z');
            const day = d.toLocaleString(
                'en-US',
                { timeZone: this.timeZoneStrHotel }
            );
            return moment(day).format(outputFormat);
        },
        utcConvertToTimeZone(date, timeZoneStr) {
            const outputFormat = this.$i18n.locale === 'en' ? "YYYY/MM/DD HH:mm" : "DD/MM/YYYY HH:mm";
            var d = new Date(date + 'Z');
            const day = d.toLocaleString(
                'en-US',
                { timeZone: timeZoneStr }
            );
            return moment(day).format(outputFormat);
        },
        formatDateTime(date) {
            const outputFormat = this.$i18n.locale === 'vi' ? "DD/MM/YYYY HH:mm:ss" : "YYYY/MM/DD HH:mm:ss";
            return moment(date).format(outputFormat) + ' (UTC)';
        },
        findTimeZone(timeZoneStr) {
            let gmt = null;
            this.optionUTC.forEach(item => {
                item.children.forEach(child => {
                    if (child.id === timeZoneStr) {
                        gmt = child.label;
                        return;
                    }
                })
            })
            return gmt;
        },
        deepObjectEqual(object1, object2) {
            const keys1 = Object.keys(object1);
            const keys2 = Object.keys(object2);

            if (keys1.length !== keys2.length) {
                return false;
            }

            for (const key of keys1) {
                const val1 = object1[key];
                const val2 = object2[key];
                const areObjects = this.isObject(val1) && this.isObject(val2);

                if (
                    areObjects && !this.deepObjectEqual(val1, val2) ||
                    !areObjects && val1 !== val2
                ) {
                    return false;
                }
            }

            return true;
        },
        isObject(object) {
            return object != null && typeof object === 'object';
        },
        removeChips(index, arr) {
            if (index >= 0) arr.splice(index, 1)
        },
        fnCount(count) {
            return `(+ ${count})`
        },
        checkRoleFunc(role) {
            const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
            return currentUser.user.roles.find(e => e.fnCode === role) ? true : false;
        },
        copyText(text) {
            let textArea = document.createElement("textarea");
            textArea.value = text;
            
            // Đảm bảo rằng trường văn bản không xuất hiện ngoài màn hình
            textArea.style.position = "fixed";
            textArea.style.left = "-999999px";
          
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
          
            try {
              document.execCommand('copy');
              _alert({responseCode: 0}, this.$t('COPY_SUCCESS'), false);
            } catch (err) {
              console.error('Unable to copy text', err);
            }
          
            document.body.removeChild(textArea);
            
          },
        formatMoney(value, currency) {
            if(value) {
                if (currency === 'VND') {
                    return value.toFixed()
                } else {
                    return value.toFixed(2)
                }
            }
        },
        roomStatus(value) {
            return this.$t('ROOM_STATUS_'+value)
        },
        deepCopyArrayWithDates(array) {
            return array.map(item => {
              if (item instanceof Date) {
                return new Date(item.getTime());
              } else if (Array.isArray(item)) {
                return deepCopyArrayWithDates(item);
              } else if (item && typeof item === 'object') {
                return deepCopyObjectWithDates(item);
              } else {
                return item;
              }
            });
        },
    },
    computed: {
        listLangI18n() {
            const listI18ns = localStorage.getItem('listI18ns');
            try {
                return listI18ns ? JSON.parse(listI18ns) : [];
            } catch (e) {
                return [];
            }
        },
        defaultI18n() {
            try {
                const hotelId = this.$route.params.hotelIdParam || null;
                const storedLanguage = localStorage.getItem('defaultLanguage');
                
                if (['vi', 'en'].includes(this.i18nLocale) && !hotelId) {
                    return this.i18nLocale;
                }
                
                if (storedLanguage && hotelId) {
                    return storedLanguage;
                }

                const browserLanguage = navigator.languages[0].split('-')[0];
                return ['vi', 'en'].includes(browserLanguage) ? browserLanguage : "en";
            } catch (e) {
                return "en";
            }
        },
        prefixCurrency() {
            return this.currencyData.prefixCurrency.includes(this.i18nLocale) ? this.usedCurrency : '';
        },
        suffixCurrency() {
            return this.currencyData.suffixCurrency.includes(this.i18nLocale) ? this.usedCurrency : '';
        },
        dataMain() {
            const data = this.jsonData[this.domain] ? this.jsonData[this.domain] : null;
            return data
        },
        usedCurrency() {
            const queryString = window.location.href;
            let hotel =  JSON.parse(localStorage.getItem("arrToken") || []).filter(e => e.hotel !== null && e.hotel.id === queryString.split('/')[4])[0];
            return !hotel ? "VND" : hotel.usedCurrency
        },
        timeZoneStrHotel() {
            const queryString = window.location.href;
            let hotel =  JSON.parse(localStorage.getItem("arrToken") || []).filter(e => e.hotel !== null && e.hotel.id === queryString.split('/')[4])[0];
            return !hotel ? "Asia/Ho_Chi_Minh" : hotel.timeZoneStr
        },
        listOtaConnectGlobal() {
            let list = JSON.parse(localStorage.getItem("listOtaConnect") || '');
            return list ;
        },
        languageDate() {
            return {
                formatLocale: {
                    months: [
                        `${this.$t('TH1')}`,
                        `${this.$t('TH2')}`,
                        `${this.$t('TH3')}`,
                        `${this.$t('TH4')}`,
                        `${this.$t('TH5')}`,
                        `${this.$t('TH6')}`,
                        `${this.$t('TH7')}`,
                        `${this.$t('TH8')}`,
                        `${this.$t('TH9')}`,
                        `${this.$t('TH10')}`,
                        `${this.$t('TH11')}`,
                        `${this.$t('TH12')}`,
                    ],
                    // MMM
                    monthsShort: [
                        `${this.$t('TH1')}`,
                        `${this.$t('TH2')}`,
                        `${this.$t('TH3')}`,
                        `${this.$t('TH4')}`,
                        `${this.$t('TH5')}`,
                        `${this.$t('TH6')}`,
                        `${this.$t('TH7')}`,
                        `${this.$t('TH8')}`,
                        `${this.$t('TH9')}`,
                        `${this.$t('TH10')}`,
                        `${this.$t('TH11')}`,
                        `${this.$t('TH12')}`,
                    ],
                    // dddd
                    weekdays: [
                        `${this.$t('T8')}`,
                        `${this.$t('T2')}`,
                        `${this.$t('T3')}`,
                        `${this.$t('T4')}`,
                        `${this.$t('T5')}`,
                        `${this.$t('T6')}`,
                        `${this.$t('T7')}`,
                    ],
                    // ddd
                    weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                    // dd
                    weekdaysMin: [
                        `${this.$t('T8')}`,
                        `${this.$t('T2')}`,
                        `${this.$t('T3')}`,
                        `${this.$t('T4')}`,
                        `${this.$t('T5')}`,
                        `${this.$t('T6')}`,
                        `${this.$t('T7')}`,
                    ],
                    // first day of week
                    firstDayOfWeek: 1,
                },
                monthBeforeYear: false,
            };
        },
        mobiTablet() {
            let device = localStorage.getItem("device") || '';
            if (device === 'DESKTOP' && isMobile === true) {
                return false
            } else if (device !== 'DESKTOP' && isMobile === true) {
                localStorage.setItem("device", 'MOBILE');
                return true
            } else if (isMobile === false) {
                localStorage.setItem("device", 'DESKTOP');
                return false
            }
        },

        priceOptionsEn() {
            const queryString = window.location.href;
            let hotelUsed = null
            let hotel =  JSON.parse(localStorage.getItem("arrToken") || "");
            if (hotel) {
                hotelUsed = hotel.filter(e => e.hotel !== null && e.hotel.id === queryString.split('/')[4])[0]
            }
            return {
                type: 'currency',
                prefix: hotelUsed ? hotelUsed.usedCurrency : "",
                locale: this.$i18n.locale,
                precision: 2,
              };
        },
        priceOptionsVi() {
            const queryString = window.location.href;
            let hotelUsed = null
            let hotel =  JSON.parse(localStorage.getItem("arrToken") || "");
            if (hotel) {
                hotelUsed = hotel.filter(e => e.hotel !== null && e.hotel.id === queryString.split('/')[4])[0]
            }
            return {
                type: 'currency',
                suffix: hotelUsed ? hotelUsed.usedCurrency : "",
                locale: this.$i18n.locale,
                precision: 0,
              };
        }
    }
};
export default Global;